// extracted by mini-css-extract-plugin
export var fadeInOut = "_2n-3";
export var icon = "_2n-4";
export var savedIndicator = "_2n-2";
export var savingIndicator = "_2n-0";
export var spin = "_2n-1";